import AdminAccessCodesModule from './AdminAccessCodesModule';

export default AdminAccessCodesModule;
